<div class="icon-tile -parent">
  <div class="icon-tile -wrapper">
    <icon
      [icon]="icon"
      [ngClass]="'-colorSupportingWhite -tile-size'"
    ></icon>
  </div>
</div>